<template>
  <v-divider class="em-divider" v-bind="$attrs" />
</template>
<style scoped>
.em-divider{
  color: rgb(var(--v-theme-neutral-lighten-4)) !important;
  opacity: 1 !important;
}
</style>
